export default __webpack_public_path__ + "static/media/process.32dff29c.png";